/** Waiting-list config shipped with the public session mint
 * (waitlist README §4.1). Module-level store — set once at bootstrap. */
export type WaitlistConfig = { active: boolean; horizon_days: number };

let config: WaitlistConfig | null = null;

export function setWaitlistConfig(cfg: WaitlistConfig | null): void {
  config = cfg;
}

export function getWaitlistConfig(): WaitlistConfig | null {
  return config;
}
